export default {"otherBookieWrapper":"UM-Bk","otherBookies":"Mu6Se"};